import { motion } from 'framer-motion';
import { Reveal, fadeUp, stagger } from './helpers';

export const Concept = () => (
    <section id="concept" className="py-32 scroll-mt-16 border-t border-border/40 relative">
        <div className="max-w-6xl mx-auto px-6">
            <Reveal className="max-w-3xl mb-20">
                <p className="text-[11px] uppercase tracking-[0.2em] text-primary font-semibold mb-5">Why it matters</p>
                <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-[-0.025em] leading-[1.05]">
                    Every departure that matters is two problems at once.
                    <span className="text-muted-foreground/60"> We solve both.</span>
                </h2>
            </Reveal>

            <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true, margin: '-80px' }} className="grid grid-cols-1 md:grid-cols-2 gap-x-14 gap-y-10">
                <motion.div variants={fadeUp}>
                    <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-semibold mb-3">For the company</div>
                    <h3 className="text-2xl font-semibold tracking-tight mb-4 leading-snug">The new person needs to do the job. From day one.</h3>
                    <p className="text-base text-muted-foreground leading-relaxed">
                        When the person who actually knows how things work leaves, years of judgment walk out with them — the relationships, the rules of thumb, the reasons behind every decision.
                        Their replacement spends six months catching up. Handoff engineers that know-how into a working system, so the next person inherits the playbook on day one — not in month
                        six.
                    </p>
                </motion.div>

                <motion.div variants={fadeUp}>
                    <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-semibold mb-3">For the person leaving</div>
                    <h3 className="text-2xl font-semibold tracking-tight mb-4 leading-snug">Years of work, with something on paper to show for it.</h3>
                    <p className="text-base text-muted-foreground leading-relaxed">
                        Most experienced people walk out of a role with a final-day card and nothing else. Handoff turns what they shared into five personal documents — a profile of how they
                        think, a record of what they built. Theirs to keep, in their own words.
                    </p>
                </motion.div>
            </motion.div>
        </div>
    </section>
);
